"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCachedAuth0Token = void 0;
const TOKEN_CACHE_KEY = 'auth0Token';
const getCachedAuth0Token = () => {
    return sessionStorage.getItem(TOKEN_CACHE_KEY);
};
exports.getCachedAuth0Token = getCachedAuth0Token;
//# sourceMappingURL=auth0Tokens.js.map